import React from 'react';
import { Box } from '@mui/material';

export interface MarketingContentImgPreviewProps {
  imageUrl?: string;
}

export const MarketingContentImgPreview: React.FC<MarketingContentImgPreviewProps> = ({
  imageUrl,
}) => {
  return (
    <Box
      width={48}
      height={48}
      flexShrink={0}
      borderRadius='8px'
      sx={({ palette }) => ({
        ...(imageUrl
          ? {
              backgroundImage: imageUrl ? `url('${imageUrl}')` : '',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : { backgroundColor: palette.grey[300] }),
      })}
    />
  );
};
